export const SUPPORTED_COUNTRY_CODES = ['DE', 'CH', 'AT'] as const;

export type SupportedCountryCodes = (typeof SUPPORTED_COUNTRY_CODES)[number];

export const POSTAL_CODE_LENGTH_BY_COUNTRY: Record<SupportedCountryCodes, number> = {
  DE: 5,
  CH: 4,
  AT: 4,
};

export const getPostalCodeLength = (country: string) => {
  switch (country) {
    case 'DE':
    case 'Deutschland':
    case 'Germany':
      return POSTAL_CODE_LENGTH_BY_COUNTRY.DE;

    case 'AT':
    case 'Austria':
    case 'Österreich':
      return POSTAL_CODE_LENGTH_BY_COUNTRY.AT;

    case 'CH':
    case 'Schweiz':
    case 'Switzerland':
      return POSTAL_CODE_LENGTH_BY_COUNTRY.CH;

    default:
      return -1;
  }
};
